import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { extractDefaultStoreId, extractNumber, HxAuthService, HxReportService, HxUiLabelPipe, StoreProductInfoModel, toRouterQueryParams } from 'hx-services';
import { takeUntil } from 'rxjs/operators';
import { HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-storage-invoices-reports.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './storage-invoices-reports.component.html',
    styleUrls: ['./storage-invoices-reports.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, NgIf, NgFor, NgClass, HxLoaderComponent, TranslocoPipe, HxUiLabelPipe]
})
export class StorageInvoicesReportsComponent implements OnInit, OnDestroy {
  list: StoreProductInfoModel[] = [];
  isLoading = {
    list: false,
  };
  params: { storeId?: number } = {};
  private $destroyed = new Subject<void>();

  constructor(
    private reportService: HxReportService,
    private auth: HxAuthService,
    private router: Router,
    private aRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed)).subscribe(async paramMap => {
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      if (this.params.storeId) {
        await this.loadList();
      }
    });
  }

  ngOnDestroy() {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  applyFilters() {
    this.navigate();
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  resetFilter() {
    this.params = {};
    this.navigate();
  }

  async loadList() {
    this.list = [];
    this.isLoading.list = true;
    try {
      this.list = await this.reportService.getStoreProductInfo(this.params);
    } finally {
      this.isLoading.list = false;
    }
  }
}
